export const BROKER_GUIDE_SECTION_NAMES = Object.freeze({
  FILING_REQUIREMENTS_PROCEDURE: "FilingRequirementsAndProcedures",
});